export default "__VITE_PUBLIC_ASSET__6adcf0f2__"